/**
 * CSRF tools
 */

/**
 * Get the CSRF token name and value generated in the <meta> tag.
 * @returns {object} An object containing both the CSRF token name and value
 */
export function getCSRF() {
    const metaCsrf = document.querySelector('meta[name="csrf"]');
    if (!metaCsrf) {
        return null;
    }
    const metaCsrfContents = metaCsrf.getAttribute('content').split('||');
    return {
        name: metaCsrfContents[0],
        token: metaCsrfContents[1],
    };
}
